/**
 * 数据请求的唯一入口
 */

import user from './user'
import role from './role'
import menu from './menu'
import token from './token'
import dict  from './dict'
import country from './country'
import genID from './genID'
import captcha from './captcha'
import release from './release'
import org from './org'
import i18n from './i18n'
import param from './param'


 export default {
     user,
     role,
     menu,
     token,
     dict,
     country,
     genID,
     captcha,
     release,
     org,
     i18n,
     param
 }